'use client';

import { Product } from '@interface/product';
import { useImageProps } from '@utils/common';
import Image from 'next/image';

export default function LongevityImgHeader({ product }: { product: Product }) {
  const { imgSrc } = useImageProps(product);

  return <Image src={imgSrc} alt={product?.title} height={800} width={800} />;
}
